import { render, staticRenderFns } from "./RadiogroupDropdownSimple.vue?vue&type=template&id=6fbffbec&scoped=true&"
import script from "./RadiogroupDropdownSimple.vue?vue&type=script&lang=js&"
export * from "./RadiogroupDropdownSimple.vue?vue&type=script&lang=js&"
import style0 from "./RadiogroupDropdownSimple.vue?vue&type=style&index=0&id=6fbffbec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbffbec",
  null
  
)

export default component.exports